
<div class="container-fluid footer">
	<div class="container">
		Ruszinkó Marcell @ Minden jog fentartva!
	</div>
</div>
